/*
TODO: Update this component to use your client-side framework's link
component. We've provided examples of how to do this for Next.js,
Remix, and Inertia.js in the Catalyst documentation:

https://catalyst.tailwindui.com/docs#client-side-router-integration
*/ import { jsx as _jsx } from "react/jsx-runtime";
import { DataInteractive as HeadlessDataInteractive } from "@headlessui/react";
import React from "react";
export const Link = /*#__PURE__*/ React.forwardRef(function Link(props, ref) {
    return /*#__PURE__*/ _jsx(HeadlessDataInteractive, {
        children: /*#__PURE__*/ _jsx("a", {
            ...props,
            ref: ref
        })
    });
});
